<template>
  <v-card :height="fillHeight ? '100%' : 'auto'">
    <v-panel-title @click="switchItems()" :value="this.isLoaded" :caption="this.isLoaded ? 'Свернуть' : 'Загрузить'" :expandable="true">
      <div
        v-show="isLoading"
        class="text-xs-center">
        <v-progress-circular
          indeterminate
          color="primary"
        ></v-progress-circular>
      </div>
      <div v-show="!isLoading">
        История изменений
      </div>
      </v-panel-title>
      <v-card-text v-show="isLoaded" class="pt-0">
      <div v-show="!isLoading">
        <div>
          <b>Названия ({{names.items.length}}):</b>
          <v-flex pl-2>
            <template v-for="item in names.items">
              <div>
                {{getCompanyNameFull(item)}}
                <v-component :is="renderCopyButton('Копировать название', getCompanyNameFull, item)" />
                <v-flex pl-2>
                  <div>Кратко: {{getCompanyNameShort(item)}}
                    <v-component :is="renderCopyButton('Копировать краткое название', getCompanyNameShort, item)" />
                  </div>
                  <div v-html="renderDateSince(item)"></div>
                  <div v-html="renderUnreliableHtml(item)"></div>                  
                </v-flex>
              </div>
            </template>
          </v-flex>
        </div>  
        <div>
          <b>Адреса ({{addresses.items.length}}):</b>
          <v-flex pl-2>
            <template v-for="item in addresses.items">
              <div>
                {{getAddress(item)}}
                <v-component :is="renderCopyButton('Копировать название', getAddress, item)" />
                <v-flex pl-2>
                  <div v-html="renderDateSince(item)"></div>
                  <div v-html="renderUnreliableHtml(item)"></div>                  
                </v-flex>
              </div>
            </template>
          </v-flex>
        </div>
        <div>
          <b>Капитал ({{capitals.items.length}}):</b>
          <v-flex pl-2>
            <template v-for="item in capitals.items">
              <div v-html="formatCapital(item)">
              </div>
            </template>
          </v-flex>
        </div>
        <div>
          <b>Руководители ({{heads.items.length}}):</b>
          <v-flex pl-2>
            <template v-for="item in heads.items">
              <v-component :is="createEmployeeComp(item)"/>
            </template>
          </v-flex>
        </div>
        <div>
          <b>Участники ({{holders.items.length}}):</b>
          <v-flex pl-2>
            <template v-for="item in holders.items">
              <div v-show="isHolderNamespace(item,'ogrn')">
                <span v-html="renderReference(item.refObject)">
                </span>  
                <v-component :is="renderCopyButton('Копировать название', getNameFull, item)" />                
                <v-flex pl-2>
                  <div>ИНН <span v-html="renderInnHtml(item.refObject.inn)"></span>
                  <v-component :is="renderCopyButton('Копировать инн', getInn, item)" />
                  </div>
                  <div v-html="formatShares(item.shares)"></div>
                </v-flex>  
              </div>
              <div v-show="isHolderNamespace(item,'HUMAN')">
                <span v-html="renderReference(item.refObject)">
                </span>
                <v-component :is="renderCopyButton('Копировать ФИО', getNameFull, item)" />
                <v-component :is="renderContactButton('Открыть контакт физического лица', openContact, item)" />
                <v-flex pl-2>
                  <div>ИНН <span v-html="renderInnflHtml(item.refObject.inn)"></span>
                  <v-component :is="renderCopyButton('Копировать инн', getInn, item)" />
                  </div>
                  <div v-html="formatShares(item.shares)"></div>
                </v-flex>
              </div>
              <div v-show="isHolderNamespace(item,'FOREIGN')">
                <span v-html="renderReference(item.refObject)">
                </span>
                <v-component :is="renderCopyButton('Копировать название', getNameFull, item)" />                  
                <v-flex pl-2>
                  <div v-html="formatShares(item.shares)"></div>
                </v-flex>
              </div>
              <div v-show="isHolderNamespace(item,'MUNICIPAL')">
                <span>{{getMunicipalNameFull(item)}}
                </span>
                <v-component :is="renderCopyButton('Копировать название', getMunicipalNameFull, item)" />                
                <v-flex pl-2>
                  <div v-html="formatShares(item.shares)"></div>
                </v-flex>
              </div>
              <div v-show="isHolderNamespace(item,'PIF')">
                <span>{{getPifNameFull(item)}}</span>
                <v-component :is="renderCopyButton('Копировать название', getPifNameFull, item)" />                
                <v-flex pl-2>
                  <div v-html="formatShares(item.shares)"></div>
                </v-flex>
              </div>
              <div v-show="isHolderNamespace(item,'OTHER')">
                <span v-html="renderReference(item.refObject)">
                </span>  
                <v-flex pl-2>
                  <div v-html="formatWarningHtml('Запись об учредителе не поддерживается.')" ></div>
                  <div v-html="formatShares(item.shares)"></div>
                </v-flex>
              </div>
              <span v-html="renderUnreliableHtml(item)"></span>
            </template>
          </v-flex>
        </div>
      </div>  
      </v-card-text>
  </v-card>
</template>

<script>
  import { mapGetters } from 'vuex'
  import formats from '../../api/formats'
  import server from '../../api/server'
  import vPanelTitle from './PanelTitle'
  import people from '../people/index'

  class Items {
    constructor (id, f) {
      this.id = id
      this.getFunction = f
      this.fill([])
    }
    lock () {
      this.isLoading = true
    }
    unlock () {
      this.isLoading = false
    }
    fill (data) {
      this.items = data
      this.isLoading = false
    }

  }

  export default {
    name: 'v-history-panel',
    components: {vPanelTitle},
    data: () => ({
      id: null,
      item: null,
      isLoaded: false,
      names: null,
      addresses: null,
      capitals: null,
      heads: null,
      holders: null,
      lists: []
    }),
    props: {
      ogrn: {
        type: Number,
        default: null
      },
      fillHeight: {
        type: Boolean,
        default: false
      }
    },
    watch: {
      ogrn: function (newVal, oldVal) { // watch it
        this.id = newVal
        this.initData()
      }
    },
    created () {
      this.initData()
    },
    computed: {
      ...mapGetters({
        getRefToUrl: 'getRefToUrl',
        renderReference: 'renderReference',
        renderCopyButton: 'renderCopyButton',
        renderContactButton: 'renderContactButton',
        renderEmployeeReference: 'renderEmployeeReference',
        renderInnHtml: 'renderInnHtml',
        renderInnflHtml: 'renderInnflHtml',
        renderDateSince: 'renderDateSince',
        renderUnreliableHtml: 'renderUnreliableHtml',
        getIconName: 'getIconName'
      }),
      isLoading () {
        return this.names.isLoading ||
          this.addresses.isLoading ||
          this.capitals.isLoading ||
          this.heads.isLoading ||
          this.holders.isLoading
      }
    },
    methods: {
      switchItems () {
        this.isLoaded = !this.isLoaded
        if (this.isLoaded) {
          this.fetchData()
        }
      },
      fetchData () {
        this.fetchItems(this.names)
        this.fetchItems(this.addresses)
        this.fetchItems(this.capitals)
        this.fetchItems(this.heads)
        this.fetchItems(this.holders)
      },
      initData () {
        this.isLoaded = false
        this.names = new Items(this.id, this.getNameItems)
        this.addresses = new Items(this.id, this.getAddressItems)
        this.capitals = new Items(this.id, this.getCapitalItems)
        this.heads = new Items(this.id, this.getHeadItems)
        this.holders = new Items(this.id, this.getHolderItems)
      },
      formatCurrency (number) {
        return number !== null ? formats.formatCurrency(number) + ' руб.' : ''
      },
      formatCapital (capital) {
        if (!capital) {
          return formats.formatWarningHtml('ЕГРЮЛ не содержит запись об уставном капитале компании')
        }
        return ''.concat(
          '<div>',
          capital.type ? capital.type + ':' : formats.formatWarningHtml('ЕГРЮЛ не содержит запись о типе уставнго капитала'),
          ' <b>' + this.formatCurrency(capital.value) + '</b>',
          this.renderDateSince(capital),
          '</div>',
          '<div>',
          this.formatLessenings(capital),
          formats.formatWarningHtml(capital.desc),
          '</div>'
          )
      },
      formatLessenings (capital) {
        if (!capital.lessenings) {
          return ''
        }
        var result = ''
        capital.lessenings.forEach(l => {
          result = result.concat(
          '<div>',
          '\xa0\xa0',
          'Уменьшение капитала на ',
          this.formatCurrency(l.value),
          this.renderDateSince(l),
          '</div>'
          )
        })
        return result
      },
      createEmployeeComp (employee) {
        var self = this
        var template = `
        <div>
        <div>
          {{employee.position}}
          <v-component :is="self.renderCopyButton('Копировать должность', getPosition)" /> :
        </div>
        <span v-html="self.renderEmployeeReference(employee)"></span>
        <v-component :is="self.renderCopyButton('Копировать ФИО', getNameFull)" />
        <v-component :is="self.renderContactButton('Открыть контакт физического лица', openContact)" />
          <div>
            ИНН ${self.renderInnflHtml(employee.inn)}
            <v-component :is="self.renderCopyButton('Копировать ИНН', getInn)" />
          </div>
          <div> ${self.renderDateSince(employee)}</div>
          <div> ${self.renderUnreliableHtml(employee)}</div>
          <div> ${self.formatDisqHtml(employee.disqualification)}</div>
        </div>
        `
        return {
          template: template,
          data: function () {
            return {
              self: self,
              employee: employee
            }
          },
          methods: {
            getPosition () {
              return `${formats.getValue(employee, ['position'])}`
            },
            getNameFull () {
              return `${formats.getValue(employee, ['nameFull'])}`
            },
            getInn () {
              return `${formats.formatInnfl(formats.getValue(employee, ['inn']))}`
            },
            openContact () {
              let refCode = formats.getValue(self.company, ['reference', 'ref'])
              people.openByHuman(refCode, employee)
            }
          }
        }
      },
      formatDisqHtml (disq) {
        if (!disq) {
          return ''
        }
        return formats.formatErrorHtml(`Дисквалифиция с ${formats.formatDate(disq.fromDate)} по ${formats.formatDate(disq.toDate)} решение от ${formats.formatDate(disq.decisionDate)}`)
      },
      formatShares (shares) {
        const fShare = (v) => v ? `(${this.formatCurrency(v)})` : ``
        const fPercent = (v) => v ? `${v}%` : ``
        const fSince = (v) => this.renderDateSince(v)
        var result = ''
        shares.forEach(s => {
          result = result.concat(`<div><b>${fPercent(s.percent)} ${fShare(s.share)}</b> ${fSince(s)}</div>`)
        })
        return result
      },
      formatWarningHtml (message) {
        return formats.formatWarningHtml(message)
      },
      getCompanyNameFull (item) {
        return `${formats.getValue(item, ['value'])}`
      },
      getCompanyNameShort (item) {
        return `${formats.getValue(item, ['nameShort'])}`
      },
      getAddress (item) {
        return `${formats.getValue(item, ['value'])}`
      },
      getNameFull (item) {
        return `${formats.getValue(item, ['refObject', 'name'])}`
      },
      getMunicipalNameFull (item) {
        return `${formats.getValue(item, ['refObject', 'desc'])}`
      },
      getPifNameFull (item) {
        return `${formats.getValue(item, ['name'])}`
      },

      getInn (item) {
        return `${formats.getValue(item, ['refObject', 'inn'])}`
      },
      openContact (item) {
        console.log('openContact', item)
        let names = this.getNameFull(item).split(' ')
        let ops = {
          inn: this.getInn(item),
          lastName: names.length > 0 ? names[0] : '',
          firstName: names.length > 1 ? names[1] : '',
          middleName: names.length > 2 ? names[2] : '',
          position: 'Участник'
        }
        people.openByHuman(null, ops)
      },
      isHolderNamespace (item, namespace) {
        return item && item.refObject && formats.compareString(item.refObject.namespace, namespace) === 0
      },
      getNameItems (list, cb) {
        const cbError = (e) => {
          list.unlock()
          this.$store.commit('setErrorStatus', {error: e, context: 'Ошибка сервера при получении информации об названиях компании '})
        }
        server.openApiGet(
          '/openapi/companies/' + list.id + '/names',
          cb,
          cbError)
      },
      getAddressItems (list, cb) {
        const cbError = (e) => {
          list.unlock()
          this.$store.commit('setErrorStatus', {error: e, context: 'Ошибка сервера при получении информации об адресах компании '})
        }
        server.openApiGet(
          '/openapi/companies/' + list.id + '/addresses',
          cb,
          cbError)
      },
      getCapitalItems (list, cb) {
        const cbError = (e) => {
          list.unlock()
          this.$store.commit('setErrorStatus', {error: e, context: 'Ошибка сервера при получении информации об изменении капитала компании '})
        }
        server.openApiGet(
          '/openapi/companies/' + list.id + '/capitals',
          cb,
          cbError)
      },
      getHeadItems (list, cb) {
        const cbError = (e) => {
          list.unlock()
          this.$store.commit('setErrorStatus', {error: e, context: 'Ошибка сервера при получении информации об изменении руководителей компании '})
        }
        server.openApiGet(
          '/openapi/companies/' + list.id + '/heads',
          cb,
          cbError)
      },
      getHolderItems (list, cb) {
        const cbError = (e) => {
          list.unlock()
          this.$store.commit('setErrorStatus', {error: e, context: 'Ошибка сервера при получении информации об изменении участников компании '})
        }
        server.openApiGet(
          '/openapi/companies/' + list.id + '/owners',
          cb,
          cbError)
      },
      fetchItems (list) {
        if (list.id && !list.isLoading) {
          list.lock()
          list.getFunction(list, (data) => {
            list.fill(data)
          })
        }
      }
    }
  }

</script>




// WEBPACK FOOTER //
// HistoryPanel.vue?0012f78b